function usdFormatter(number) {
  if (number && number > 0) {
    return "$" + number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  } else {
    return "$0.00";
  }
  
}

export default usdFormatter;